// eslint-disable-next-line import/no-cycle
import { getApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({}),
	mutations: {},
	actions: {
		async getContractHistory(_, { page, sort }) {
			const response = await getApi(`/k5/v1/contract/get-contracts?sort_by=date&sort=${sort}&page=${page}`);
			return response;
		},
		async getDebtDocument(_, contract_uid) {
			const response = await getApi(`/k5/v1/contract/get-debt-document?contract_uid=${contract_uid}`);
			return response;
		},
	},
	getters: {},
};
